<template>
  <div class="mapBox">
    <!-- 地图区域 -->
    <mapCenter :searchChange="searchChangeVal" :clearMapTool="clearMapToolVal" @ismapcompelate='mapcompeltefn'>
    </mapCenter>
    <!-- 搜索区域 -->
    <mapSearch @startSearch="startSearchFun" :searchResult="searchResultValue" :searchId="searchIdArray" :searchWord="searchKeyword"
      :searchResultTool="searchResultToolValue"></mapSearch>
    <!-- 查询结果 -->
    <mapResult :seachParams="seachParamsJson" @clearSearch="clearSearchFun" @clearTools="clearToolsFun" @searchEnd="searchEndFun"></mapResult>
  </div>
</template>

<script>

import mapCenter from "./mapTools/mapCenter.vue";
import mapSearch from "./mapTools/mapSearch.vue";
import mapResult from "./mapTools/mapResult.vue";
export default {
  name: "productSearch",
  data() {
    return {
      mapBase: null,
      seachParamsJson: {},
      searchResultValue: false,
      searchResultToolValue: false,
      clearMapToolVal: '',
      searchChangeVal:'',
      // id查询
      searchIdArray:[],
      // 模糊查询
      searchKeyword:''
    };
  },
  components: {
    mapSearch,
    mapResult,
    mapCenter
  },
  mounted() {
    let acceptData = this.$route.query;
    let handlerStr = acceptData.search.trim();
    if(acceptData.goodsId && acceptData.goodsId.length > 0){
      this.searchIdArray = acceptData.goodsId.split(',');
    }
    if(handlerStr.length > 0){
      this.searchKeyword = handlerStr;
    }
  },
  methods: {
    //判断子组件的地图是否渲染完成
    mapcompeltefn(map) {
      if (map) {
        // console.log(map);
        // return false;
        //提交地图对象
        // setTimeout(item=>{
        //   this.$store.dispatch("productSearch/updateMappubObj", map)
        // },1000)
      }
    },
    // 查询接口结束触发查询按钮状态
    searchEndFun(value) {
      // console.log('查询接口反馈：', value);
      this.searchResultValue = !this.searchResultValue;
    },
    // 筛选条件触发查询参数接受
    startSearchFun(param) {
      // console.log("触发查询参数接受:", param);
      this.searchIdArray = [];
      this.seachParamsJson = param;

    },
    clearSearchFun(e) {
      // console.log(e);
      if(e){
        this.searchChangeVal = (new Date().valueOf()).toString();
      }
    },
    // 清除工具信息
    clearToolsFun(e) {
      if (e) {
        this.clearMapToolVal = (new Date().valueOf()).toString();
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.mapBox {
  width: 100%;
  height: 100vh;
  min-width: 1000px;
  background-color: rgb(192, 192, 192);
  position: relative;
  overflow: hidden;

  .productMapWrap {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
}
</style>
